<div
  class="cursor-pointer w-full overflow-hidden grid grid-cols-[1fr_auto]"
  [style.background-color]="bgColor"
  (click)="handleClick()"
>
  <div class="py-2 text-lg lg:text-xl text-white overflow-hidden min-w-0">
    <div #trackRef class="whitespace-nowrap text-nowrap uppercase italic marquee-hover-pause">
      <div class="inline-flex items-center will-change-transform marquee-inner">
        <div #lineRef class="flex">
          <ng-container *ngFor="let v of bannerText; let i = index">
            <div class="flex items-center gap-6 select-none">
              <p>{{ v }}</p>
              <div class="w-[6px] h-[6px] rounded-full bg-white"></div>
            </div>
            <div class="w-6 shrink-0"></div>
          </ng-container>
        </div>
        <ng-container *ngFor="let copyIdx of getCopiesArray()">
          <div class="flex">
            <ng-container *ngFor="let v of bannerText; let i = index">
              <div class="flex items-center gap-6 select-none">
                <p>{{ v }}</p>
                <div class="w-[6px] h-[6px] rounded-full bg-white"></div>
              </div>
              <div class="w-6 shrink-0"></div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <button
    aria-label="Close banner"
    class="hover:opacity-80 flex items-center justify-center w-11 px-2"
    (click)="handleClose($event)"
  >
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" style="display: block;">
      <path fill="white"
        d="M18.3 5.7a1 1 0 0 0-1.4 0L12 10.6 7.1 5.7A1 1 0 1 0 5.7 7.1L10.6 12l-4.9 4.9a1 1 0 1 0 1.4 1.4L12 13.4l4.9 4.9a1 1 0 0 0 1.4-1.4L13.4 12l4.9-4.9a1 1 0 0 0 0-1.4z" />
      </svg>
  </button>
</div>